// extracted by mini-css-extract-plugin
export default {"couponContainer":"bh_fG","templateTwo":"bh_cN","coupon":"bh_fH","copied":"bh_fJ","noCode":"bh_fK","disabled":"bh_fL"};